// Layout.jsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import App from "./pages/App.jsx";

import Login from "./pages/Login.jsx";
import Activate from "./pages/ActivateAccount.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";

import Calendary from "./pages/Calendary.jsx";
import Patients from "./pages/Patients.jsx";
import PatientDetail from "./components/PatientDetail.jsx";
import Profile from "./components/Profile.jsx";
import ChatLayout from "./pages/ChatLayout.jsx";
import ChatRoom from "./components/ChatRoom.jsx";
import Assistant from "./pages/Assistant.jsx";
import CRMPage from "./pages/CrmLayout.jsx";
import PatientPage from "./pages/PatientLayout.jsx";
import HrEmployeeDashboard from "./pages/HrEmployeeDashboard.jsx";
import HrManagerDashboard from "./pages/HrManagerDashboard.jsx";

const PrivateRoute = ({ children }) => {
  const token = useSelector((state) => state.auth.token);
  return token ? children : <Navigate to="/log-in" />;
};

const RoleRoute = ({ allowedRoles, children }) => {
  const user = useSelector((state) => state.auth.user);
  const role = (user?.role || "").toLowerCase();

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/appointments" />;
  }

  return children;
};

const Layout = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC */}
        <Route path="/log-in" element={<Login />} />
        <Route path="/activate" element={<Activate />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* PRIVATE */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <App />
            </PrivateRoute>
          }
        >
          <Route path="appointments" element={<Calendary />} />
          <Route path="profile" element={<Profile />} />
          <Route path="assistant" element={<Assistant />} />
          <Route path="patients" element={<Patients />} />
          <Route path="patients/:id" element={<PatientPage />} />
          <Route path="hr/employee" element={<HrEmployeeDashboard />} />
          <Route path="hr/manager" element={<HrManagerDashboard />} />

          {/* ✅ CRM solo admin + receptionist */}
          <Route
            path="crm"
            element={
              <RoleRoute allowedRoles={["admin", "receptionist"]}>
                <CRMPage />
              </RoleRoute>
            }
          />

          <Route path="chats" element={<ChatLayout />}>
            <Route index element={<ChatRoom />} />
            <Route path=":chatId" element={<ChatRoom />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/appointments" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Layout;